import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import { autorun } from 'mobx';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../Form';
import TabBar from '../TabBar';
import * as api from '../../actions/api';
import { getDisplayDate } from '../../libs/date';

@inject('requestStore')
@observer
class RequestDetail extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    requestStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = '/daq/request';
  title = 'Edit Request';
  dispose = null;
  @observable request = {
    daq_processor_id: '',
    daq_processor_parser: '',
    timestamp: '',
    payload: '',
    request_errors: [],
  };

  constructor(props) {
    super(props);

    this.onChangeName = this.onChange.bind(this, 'name');
    this.onChangeSymbol = this.onChange.bind(this, 'symbol');
    this.handleSave = this.handleSave.bind(this);
    this.generateObservation = this.generateObservation.bind(this);
  }

  componentWillMount() {
    const { params: { id }, requestStore } = this.props;

    this.dispose = autorun(() => {
      requestStore.fetchItem(id, true);

      const foundRequest = requestStore.items.find(item => +item.id === +this.props.params.id);
      console.log(foundRequest)
      this.resetInputValues(foundRequest);
    });
  }

  componentWillUnmount() { this.dispose(); }

  @action
  resetInputValues(item) {
    if (!item) { return; }
    this.request = item;
  }

  onChange(field, event) {
    console.log('field', event.target.value);
    this.request = {
      ...this.request,
      [field]: event.target.value,
    };
  }

  handleSave(e) {
    e.preventDefault();

    const { requestStore } = this.props;
    requestStore.updateItem(this.request);
    // this.context.router.push(this.slug);
  }

  generateObservation(e) {
    e.preventDefault();
    const { notify } = this.context;

    const { params: { id }, requestStore } = this.props;
    console.log('generateObservation', id);

    api.request.generateObservationByRequestId(id)
      .then(res => {
        console.log('res', res);
        notify.success({ message: 'Success' });
      })
      .catch(err => {
        notify.error(err);
        console.log('err', err);
      });
  }

  render() {
    const { params: { id }, requestStore } = this.props;

    if (requestStore.isLoading) { return <Spinner />; }

    const isRequestErrorsVisible = (this.request.request_errors && this.request.request_errors.length) > 0;

    const tabBarItems = [
      { label: 'Request Errors', to: `/daq/request/${id}/request-error`, isVisible: isRequestErrorsVisible },
      { label: 'Raw Data', to: `/daq/request/${id}/raw-data` },
      { label: 'Observation', to: `/daq/request/${id}/observation` },
      // { label: 'Origin Data', to: `request/${id}/origin-data` },
    ];


    return (
      <div>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label={'Parser'} value={this.request.daq_processor_parser} readOnly />
            <TextInput label={'Payload'} value={this.request.payload} readOnly />
            <TextInput label={'Timestamp'} value={getDisplayDate(this.request.timestamp)} readOnly />
          </FormBody>
          <FormActions>
            <button onClick={this.generateObservation}>Generate Observation</button>
          </FormActions>
        </Form>
        <TabBar items={tabBarItems} rounded />
        <div className='overflow-x-scroll'>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default RequestDetail;



// WEBPACK FOOTER //
// ./src/components/Request/RequestDetail.js